__turbopack_context__.v({
  "context": "quick-switcher-module__dbDDYW__context",
  "empty": "quick-switcher-module__dbDDYW__empty",
  "hitDot": "quick-switcher-module__dbDDYW__hitDot",
  "input": "quick-switcher-module__dbDDYW__input",
  "inputRow": "quick-switcher-module__dbDDYW__inputRow",
  "kind": "quick-switcher-module__dbDDYW__kind",
  "list": "quick-switcher-module__dbDDYW__list",
  "modeMark": "quick-switcher-module__dbDDYW__modeMark",
  "optIcon": "quick-switcher-module__dbDDYW__optIcon",
  "optLabel": "quick-switcher-module__dbDDYW__optLabel",
  "option": "quick-switcher-module__dbDDYW__option",
  "panel": "quick-switcher-module__dbDDYW__panel",
  "qs-fade": "quick-switcher-module__dbDDYW__qs-fade",
  "qs-rise": "quick-switcher-module__dbDDYW__qs-rise",
  "scrim": "quick-switcher-module__dbDDYW__scrim",
  "searchIcon": "quick-switcher-module__dbDDYW__searchIcon",
  "section": "quick-switcher-module__dbDDYW__section",
});
